import 'braid-design-system/reset'; // <-- Must be first

import { device as deviceUtils } from '@seek/ca-myprofile-utils';
import { setup as setupMetrics, metrics } from '@seek/metrics-js';
import { TrackJS } from 'trackjs';

import { hydrateFeatures } from 'src/modules/features';
import { parseUrl } from 'src/modules/utils';

import clientRender from './client-render';
import type { Config } from './config';
import { initBrowserLog } from './modules/error-logger/browserLog';
import type { ClientContext } from './render';

const { SEEK_ENV, METRICS_URL, METRICS_IS_ENABLED } = window.APP_CONFIG;

const globalTags = [
  `app-env:${SEEK_ENV}`,
  `browser-name:${deviceUtils.getBrowserName()}`,
  `device-type:${deviceUtils.getDeviceType()}`,
];

const urlParams = parseUrl(window.location);

if (urlParams.card) {
  globalTags.push(`external-url-card:${urlParams.card}`);
}

if (urlParams.field) {
  globalTags.push(`external-url-field:${urlParams.field}`);
}

if (window.SEEK_TEST) {
  globalTags.push('seek_test:true');
}

const createTrackjsConfig = (config: Config) => ({
  token: 'c0dee68c9f294d4d8011e8e45b0a74ec',
  application: 'myprofile-ui',
  console: {
    display: false,
  },
  version: config.version,
  onError: (payload: { metadata: Array<Record<string, unknown>> }) => {
    payload.metadata.push({
      key: 'zone',
      value: window.APP_CONFIG.zone,
    });
    return true;
  },
});

if (window.APP_CONFIG.TRACKJS_ENABLED) {
  TrackJS.install(createTrackjsConfig(window.APP_CONFIG));
}

initBrowserLog();

hydrateFeatures(urlParams);

setupMetrics({
  host: METRICS_URL,
  isEnabled: METRICS_IS_ENABLED,
  prefix: 'profile-web-ui',
  globalTags,
});

metrics.sendPagePerformance();

export default (clientContext: ClientContext) => {
  clientRender(clientContext);
};
